export default {
  breakpoints: ['460px', '768px', '1024px'],
  fontSizes: [
    12, 14, 16, 18, 20, 24, 32, 48, 64
  ],
  colors: {
    blue: '#0069b4',
    lightblue: '#b5c6d5',
    darkblue: '#2e4964',
    grayblue: '#93a7bb',
    sand: '#e0c599',
    yellow: '#CA9C4D',
    green: '#32727c',
    red: '#871811',
    lightgray: '#d0dbe1'
  },
  space: [
    0, 5, 10, 15, 20, 25, 30, 35
  ],
  fonts: {
    sans: "'Source Sans Pro', sans-serif;",
    serif: 'serif',
    mono: 'monospace'
  },
  shadows: {
    small: '0 0 4px rgba(0, 0, 0, .125)',
    large: '0 0 24px rgba(0, 0, 0, .125)'
  }
};
